// extracted by mini-css-extract-plugin
module.exports = {"control":"GraphFilters_control__1UWq5","label":"GraphFilters_label__1g04d"};